import { render, staticRenderFns } from "./PartnershipTermsPage.vue?vue&type=template&id=6cc24740&"
import script from "./PartnershipTermsPage.vue?vue&type=script&lang=js&"
export * from "./PartnershipTermsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports